import {NgModule} from '@angular/core';
import {GnMessageServiceModule} from '../message-service/message-service.module';
import {GnSiteInfo} from './SiteInfo';
import {GnLoginUser} from './LoginUser';
import {GnRouteGuard} from './RouteGuard';
import {GnHttpInterceptorConfig} from './HttpInterceptorConfig';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {GnOAuthHttpInterceptor} from './OAuthHttpInterceptor';
import {GnMessageService} from '../message-service/message-service';
import {NzIconService} from 'ng-zorro-antd/icon';
import zh from '@angular/common/locales/zh';
import {registerLocaleData} from '@angular/common';

registerLocaleData(zh);

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    HttpClientModule,
    GnMessageServiceModule
  ],
  providers: [
    GnSiteInfo,
    GnLoginUser,
    GnRouteGuard,
    GnHttpInterceptorConfig,
    {provide: HTTP_INTERCEPTORS, useClass: GnOAuthHttpInterceptor, multi: true}
  ]
})
export class GnAppConfigModule {

  constructor(httpClient: HttpClient,
              siteInfo: GnSiteInfo,
              iconService: NzIconService,
              messageService: GnMessageService) {
    httpClient.get('assets/config/siteInfo.json')
      .subscribe((value: GnSiteInfo) => {
          siteInfo.title = value.title;
          siteInfo.siderMenu = value.siderMenu;
          siteInfo.siderMenuTheme = value.siderMenuTheme || 'dark';
          siteInfo.showBreadcrumb = value.showBreadcrumb;
          siteInfo.siteAuthorities = value.siteAuthorities;
          siteInfo.iconFontUrl = value.iconFontUrl;

          siteInfo.authSiderMenu = siteInfo.getAuthorityMenu(siteInfo.siderMenu, '');

          iconService.fetchFromIconfont({
            scriptUrl: siteInfo.iconFontUrl
          });
        },
        error => {
          messageService.error('获取系统信息错误');
          throw error;
        });
  }

}
